import React, { useEffect, useState } from "react";
import { useConfigs } from "./components/ConfigsContext";
import { useLocation } from "react-router-dom";
import ServiceDetail from "./components/ServiceDetail.js";
import Accordion from "./components/Accordion.js";
import "./ServicesDetails.css";
import "./Global.js";

const strapiServerUrl = window.strapiServerUrl;

const ServicesDetails = () => {
  const { loading, error, data } = useConfigs();
  const [serviceData, setServiceData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (data) {
      const servicesData = data.services.data;
      setServiceData(servicesData);
    }
  }, [data]);

  useEffect(() => {
    const section = location.state?.sectionId; // Get the section ID from the passed state
    if (section) {
      const element = document.getElementById(section);
      if (element) {
        const yCoordinate =
          element.getBoundingClientRect().top + window.scrollY;
        const yOffset = -130;
        setTimeout(() => {
          window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
        }, 100); // Delay the scroll to ensure the component has rendered
      }
    }
  }, [serviceData, location.state]);

  return (
    <div className="services-details-container">
      {loading ? (
        <div className="center">Loading...</div>
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        serviceData &&
        serviceData.map((service, index) => (
          <div
            className="service-main-section"
            id={service.attributes.service_name}
            key={index}
            style={
              service.attributes.section_color && {
                backgroundColor: service.attributes.section_color,
              }
            }
          >
            <div className="service-detail-section">
              <div className="service-detail-image">
                <img
                  src={`${strapiServerUrl}${service.attributes.service_image.data.attributes.url}`}
                  alt=""
                />
              </div>
              <ServiceDetail key={index} service={service} />
            </div>
            {service.attributes.service_accordions.data.length !== 0 && (
              <div className="service-accordion" style={{ display: "block" }}>
                <Accordion
                  accordionData={service.attributes.service_accordions.data}
                />
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default ServicesDetails;
